import React from 'react'
import Processes from './Processes'
export default function MailOuts() {
  return (
    <div><Processes /></div>
  )
}
